type UpdateData = Record<string, unknown>;

/** Merges a transaction's partial updates per document; `flush` writes them. */
export const createUpdateQueue = () => {
  const updates = new Map<string, {collection: string; id: string; data: UpdateData}>();
  return {
    queue(collection: string, id: string, data: UpdateData) {
      const path = `${collection}/${id}`;
      updates.set(path, {collection, id, data: {...updates.get(path)?.data, ...data}});
    },
    flush(transaction: {update: (collection: string, id: string, data: UpdateData) => void}) {
      for (const {collection, id, data} of updates.values()) {
        transaction.update(collection, id, data);
      }
    },
  };
};
